import { useEffect } from 'react';

/**
 * Suppresses the benign "ResizeObserver loop" error that fires
 * when framer-motion / Three.js triggers layout recalculation.
 * Only suppresses that specific error — all others pass through.
 */
const ResizeObserverHandler = () => {
  useEffect(() => {
    const handler = (e) => {
      if (e.message?.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', handler);
    return () => window.removeEventListener('error', handler);
  }, []);
  return null;
};

export default ResizeObserverHandler;
